/**
 * intc-sticky-atc-visibility.js
 *
 * Shows the sticky add-to-cart bar (snippets/intc-sticky-atc.liquid) once the
 * real Add to Cart button has scrolled out of view above the viewport, and
 * hides it again if the shopper scrolls back up to it. The bar is hidden by
 * default (see assets/component-intc-sticky-atc.css) so it never appears
 * without this script.
 */
(function () {
  'use strict';

  function initStickyAtc(bar) {
    var targetId = bar.getAttribute('data-real-atc-id');
    var target = targetId && document.getElementById(targetId);
    if (!target || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.classList.toggle('intc-sticky-atc--visible', scrolledPast);
      document.body.classList.toggle('intc-sticky-atc-open', scrolledPast);
    }, { threshold: 0 });

    observer.observe(target);
  }

  document.querySelectorAll('.intc-sticky-atc[data-real-atc-id]').forEach(initStickyAtc);
})();
